import * as React from "react";
import { SVGProps } from "react";

// Converted svg to tsx with:
// https://www.svgviewer.dev/svg-to-react-jsx

export const PUBicon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={128}
    height={128}
    viewBox="-9 -9 52 52"
    id="svg1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="layer1">
      <g
        id="g28-9"
        transform="matrix(1.3184461,0,0,1.3184461,-102.22273,-113.61943)"
        style={{
          fontSize: 64,
          letterSpacing: "-2.64538px",
          wordSpacing: 0,
          whiteSpace: "pre",
          display: "inline",
          strokeWidth: 0.75847,
          fill: "currentcolor",
        }}
      >
        <path
          id="path17-1"
          style={{
            fill: "currentcolor",
            strokeWidth: 2.8095,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeDashoffset: 19.1999,
          }}
          d="m 83.48586,90.411019 a 3.3072917,3.3072917 0 0 0 -3.307291,3.307292 3.3072917,3.3072917 0 0 0 3.307291,3.307291 3.3072917,3.3072917 0 0 0 2.115633,-0.765328 c -0.07926,-0.34697 -0.120923,-0.707466 -0.120923,-1.076937 0,-1.08939 0.364401,-2.100519 0.976685,-2.917651 A 3.3072917,3.3072917 0 0 0 83.48586,90.411019 Z"
        />
        <path
          style={{
            baselineShift: "baseline",
            display: "inline",
            overflow: "visible",
            vectorEffect: "none",
            fill: "currentcolor",
            strokeWidth: 0.75847,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeDashoffset: 19.1999,
            stopColor: "#000000",
          }}
          d="M 93.683322,95.18396 A 3.3072917,3.3072917 0 0 1 90.37603,98.491252 3.3072917,3.3072917 0 0 1 87.068738,95.18396 3.3072917,3.3072917 0 0 1 90.37603,91.876668 3.3072917,3.3072917 0 0 1 93.683322,95.18396 Z"
          id="path18-2"
        />
        <path
          id="path19-7"
          style={{
            fill: "currentcolor",
            stroke: "none",
            strokeWidth: 2.40813,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeDasharray: "none",
            strokeDashoffset: 19.1999,
            strokeOpacity: 1,
          }}
          d="m 83.382507,98.226562 a 5.8499999,3.8999999 0 0 0 -5.849772,3.900018 v 4.03748 h 4.946468 v -2.57193 c 0,-2.05083 1.813579,-3.83719 4.422469,-4.680338 a 5.8499999,3.8999999 0 0 0 -3.312459,-0.68523 z m 5.842021,2.854088 c -1.659796,0.30053 -2.856673,1.30093 -2.856673,2.51148 v 2.57193 h 3.07113 v -4.03748 a 5.8499999,3.8999999 0 0 0 -0.214457,-1.04593 z"
        />
        <path
          id="path20-0"
          style={{
            fill: "currentcolor",
            strokeWidth: 2.8095,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeDashoffset: 19.1999,
          }}
          d="m 97.266414,90.411019 a 3.3072917,3.3072917 0 0 0 -2.970878,1.85415 c 0.612112,0.817213 0.976168,1.828571 0.976168,2.918168 0,0.369464 -0.04224,0.729973 -0.12144,1.076937 a 3.3072917,3.3072917 0 0 0 2.11615,0.765328 3.3072917,3.3072917 0 0 0 3.307296,-3.307291 3.3072917,3.3072917 0 0 0 -3.307296,-3.307292 z"
        />
        <path
          id="path21-9"
          style={{
            fill: "currentcolor",
            stroke: "none",
            strokeWidth: 2.40813,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeDasharray: "none",
            strokeDashoffset: 19.1999,
            strokeOpacity: 1,
          }}
          d="m 97.163062,98.226562 a 5.8499999,3.8999999 0 0 0 -3.311943,0.68523 c 2.609084,0.8431 4.421952,2.629408 4.421952,4.680338 v 2.57193 h 4.946469 v -4.03748 a 5.8499999,3.8999999 0 0 0 -5.85029,-3.900018 z m -5.635832,2.853578 a 5.8499999,3.8999999 0 0 0 -0.213941,1.04644 v 4.03748 h 3.071648 v -2.57193 c 0,-1.21069 -1.197614,-2.2116 -2.857707,-2.51199 z"
        />
        <path
          style={{
            baselineShift: "baseline",
            display: "inline",
            overflow: "visible",
            vectorEffect: "none",
            fill: "currentcolor",
            strokeWidth: 0.557358,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeDashoffset: 19.1999,
            stopColor: "#000000",
          }}
          d="m 90.272907,99.691828 h 0.206251 a 5.8499999,3.8999999 0 0 1 5.849999,3.900002 v 4.0375 h -11.90625 v -4.0375 a 5.8499999,3.8999999 0 0 1 5.85,-3.900002 z"
          id="path27-3"
        />
        <circle
          style={{
            fill: "currentcolor",
            strokeWidth: 2.8095,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeDashoffset: 19.1999,
          }}
          id="circle27-6"
          cx={90.37603}
          cy={95.18396}
          r={3.3072917}
        />
        <path
          style={{
            fill: "currentcolor",
            stroke: "none",
            strokeWidth: 3.27706,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeDasharray: "none",
            strokeDashoffset: 19.1999,
            strokeOpacity: 1,
          }}
          id="path28-0"
          width={13.229167}
          height={13.229167}
          x={62.487614}
          y={62.300526}
          d="m 68.987614,62.300526 h 0.229167 a 6.5,6.5 45 0 1 6.5,6.5 v 6.729167 H 62.487614 v -6.729167 a 6.5,6.5 135 0 1 6.5,-6.5 z"
          transform="matrix(0.89999998,0,0,0.59999999,28.184056,62.311513)"
        />
      </g>
    </g>
  </svg>
);
